import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { Stack, Box, Typography, useTheme } from '@mui/material'

import { useItemsSelected } from '../store'
import useActions from './use-actions'
import ActionModal from 'components/Modal/ActionModal'
import ProgressBar from '../components/ProgressBar'
import { trackEvent } from 'analytics'

const ResetInMass = ({onClose}) => {
  const {t} = useTranslation()
  const {roomId, siteId} = useParams()
  const navigate = useNavigate()
  const [itemsSelected, setItemsSelected] = useItemsSelected()
  const [count] = useState(itemsSelected.length)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const apiActions = useActions()
  const itemsToProcess = useRef(null)
  const theme = useTheme()
  const handleReset = async () => {
    setLoading(true)
    itemsToProcess.current = [...itemsSelected]
    let isOnError = false
    let processedCount = 0
    while (itemsToProcess.current.length && !isOnError) {
      const item = itemsToProcess.current.shift()
      const {error: e} = await apiActions.reset({roomId: item.id})
      if (e) {
        isOnError = true
        setError(e)
      } else {
        processedCount += 1
        setItemsSelected(prev => prev.filter(({id}) => id !== item.id))
      }
    }
    if (processedCount) {
      trackEvent('private_wifi_passphrase_reset', { action_scope: 'bulk', item_count: processedCount })
    }
    if (!isOnError && roomId) {
      navigate(`/ran/${siteId}`)
    }
    setLoading(false)
  }

  const handleClose = () => {
    itemsToProcess.current = []
    onClose()
  }
  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmColor="primary"
      confirmLabel={t('ui_elements.confirm')}
      description={loading
        ? (
          <Box
            sx={{
              fontSize: 14,
              textAlign: 'center'
            }}
            dangerouslySetInnerHTML={{ __html: t('ran.modal_reset.processing_detail') }}
          />
        )
        : (
          <Stack sx={{textAlign: 'center'}}>
            <Box component={'span'} sx={{fontSize: 14}}>
              {t('ran.modal_reset.detail_1')}
              <Box component={'span'} sx={{color: theme.palette.primary.main, fontWeight: 500, margin: '4px'}}>
                {count}
              </Box>
              {t('ran.modal_reset.detail_2')}
              <br />
              {t('ran.modal_reset.detail_3')}
            </Box>
          </Stack>
        )}
      hideActions={loading}
      icon={<i className={`fa-regular fa-${loading ? 'hourglass' : 'arrow-right-arrow-left'}`} />}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleReset}
      title={loading ? t('ran.modal_reset.title_loading') : t('ran.modal_reset.title')}
      variant="primary"
    >
      {Boolean(error) && <Typography color={'error'}>{t('ran.actions.error')}</Typography>}
      {loading && (
        <>
          <ProgressBar variant={'primary'} percent={((count - itemsSelected.length) * 100) / count} />
          <Stack sx={{ fontSize: 10 }} alignItems={'center'}>
            <Stack direction={'row'} gap={1} sx={{ color: theme.palette.grey[500] }}>
              <Box sx={{ fontWeight: 600 }} color={'black'}>
                {count - itemsSelected.length}
              </Box>
              {t('ran.modal_reset_counter.body', { count })}
            </Stack>
          </Stack>
        </>
      )}
    </ActionModal>
  )
}


export default ResetInMass